import { wtClientApi } from 'api/clients';

import type { GenericResponse } from 'commons/modules/generic-response';

import {
  adaptDataToGenericResponse,
  adaptErrorToGenericResponse,
} from '../shared';

import type { MoralClientDataDto, PhysicalClientDataDto } from './dto';
import {
  mapClonePersonInformationToDto,
  mapMoralClientDataDtoToModel,
  mapPhysicalClientDataDtoToModel,
} from './mappers';
import type {
  ClonePersonInformation,
  MoralClientData,
  PhysicalClientData,
} from './models';

export const cloneInformationPhysical = async (
  body: ClonePersonInformation,
): Promise<GenericResponse<PhysicalClientData>> => {
  try {
    const dto = mapClonePersonInformationToDto(body);
    const response = await wtClientApi.post<PhysicalClientDataDto>(
      '/management/clients/clone-info-fi',
      dto,
    );

    return adaptDataToGenericResponse(
      mapPhysicalClientDataDtoToModel(response.data),
      response.status,
    );
  } catch (error: any) {
    return adaptErrorToGenericResponse(
      error,
      'Ocurrió un error al clonar el cliente',
    );
  }
};

export const cloneInformationMoral = async (
  body: ClonePersonInformation,
): Promise<GenericResponse<MoralClientData>> => {
  try {
    const dto = mapClonePersonInformationToDto(body);
    const response = await wtClientApi.post<MoralClientDataDto>(
      '/management/clients/clone-info-mo',
      dto,
    );

    return adaptDataToGenericResponse(
      mapMoralClientDataDtoToModel(response.data),
      response.status,
    );
  } catch (error: any) {
    return adaptErrorToGenericResponse(
      error,
      'Ocurrió un error al clonar el cliente',
    );
  }
};
